@if (loadedError) {
  <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
  <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
<!-- <div *ngIf="!loaded" class="widget-page-loader"></div> -->
@if (loaded) {
  <div class="widget-container d-flex flex-column">
    @if (!noTitle) {
      <h1 class="widget-title align-self-center">{{ 'web.widget_form_title' | translate }}</h1>
    }
    <div class="d-flex">
      @if (data?.home; as p) {
        <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
          <div class="widget-team__name d-flex align-items-center">
            <img
              (error)="imageError($event)"
              [attr.src]="p.image | responsive: 'participant':'medium'"
              [alt]="p.name"
              class="img-fluid app-cursor mr-1"
              />
            <div>{{ p.name }}</div>
          </div>
          <div class="widget-team__form mt-1">
            <app-last-matches [limit]="6" [matches]="p.form.reverse()" [spread]="true"></app-last-matches>
          </div>
        </div>
      }
      @if (data?.away; as p) {
        <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
          <div class="widget-team__name d-flex align-items-center justify-content-end">
            <div>{{ p.name }}</div>
            <img
              (error)="imageError($event)"
              [attr.src]="p.image | responsive: 'participant':'medium'"
              [alt]="p.name"
              class="img-fluid app-cursor ml-1"
              />
          </div>
          <div class="widget-team__form align-self-end mt-1">
            <app-last-matches [limit]="6" [matches]="p.form.reverse()" [spread]="true"></app-last-matches>
          </div>
        </div>
      }
    </div>
    <div class="d-flex flex-column widget-form-participant-container">
      <widget-form-participants [formHome]="data?.home.form" [formAway]="data?.away.form">
        <span class="home">{{ data?.home?.name }}</span>
        <span class="away">{{ data?.away?.name }}</span>
      </widget-form-participants>
    </div>
    <div class="widget-logo d-flex justify-content-center mt-4">
      <img
        [src]="'/img/' + client.getName() + '.png'"
        [alt]="client.getName()"
        data-cy="logo"
        class="widget-logo-client"
        />
    </div>
  </div>
}
